import React from 'react';
import {useForm} from 'react-hook-form';
import Button from "../button";


const Step3 = (props) => {

    return (
        <div id="step-three" className="question-step step-three">
            <div className="step-title_container">
                <div className="step-number">
                    03.
                </div>

                <h2 className="question-title">Last, but certainly not least.</h2>
                <hr className="question-title_line"/>

                <div className="step-3_form clearfix col-11 col-md-10">

                    <input type="checkbox" id="see-loan" name="seeLoan" {...props.register("checked")} />
                    <p className="disclaimer-text"> By checking the box, and the "See My Loan Offers" button, I
                        hereby agree and consent to the "E-Sign Agreement", the "Credit Authorization
                        Agreement", the Terms of Service and Privacy Policy, and am providing written consent
                        under the FCRA for {props.config.name}, and its partners to obtain consumer report information
                        from my credit profile. I agree to be contacted by {props.config.name} and its partners and their
                        affiliated companies via Email and/or at the Telephone number(s) I have provided above
                        to explore various financial products and services I inquired about, including contact
                        through automatic dialing systems, artificial or pre-recorded voice messaging, or text
                        message. Consent is not required as a condition to utilize {props.config.name}, and you may
                        choose to be contacted by an individual customer care representative(s) by calling (855)
                        557-8777.</p>

                    <div className="see-offers_container">
                        <Button
                            buttonText={"See My Loan Offers"}
                            buttonColorBg={"transparent"}
                            arrowColor={'#fff'}
                            buttonHoverColor={"#A26C1D"}
                            fontColor={"#A26C1D"}
                            fontHoverColor={"#fff"}
                            fontSize={'18px'}
                            buttonWidth={'240px'}
                            buttonHeight={'60px'}
                            buttonBorderWidth={'2px'}
                            linkTarget={'_blank'}
                            linkDestination={''}
                            callback={() => props.submit()}
                            submit
                        />

                    </div>
                    <div className="button-subtext">
                        won’t affect your credit score!*
                    </div>

                </div>

            </div>
        </div>
    )
}

export default Step3;
